import { Component, inject, OnInit, signal } from '@angular/core';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';
// pake relative path
import { InputEmailComponent } from '../../../../shared/components/input-email/input-email.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { GetPackageDetailUsecase } from '@usecase/package/get-package-detail/get-package-detail.usecase';
import { GetPackageDetailDto, GetPackageDetailResp } from '@usecase/package/get-package-detail/get-package-detail.type';
import { ActivatedRoute } from '@angular/router';
import { Package } from '@data/domain/package.entity';
import { DialogService } from '@shared/component.dialog';
import { PromoDetailComponent } from '@presentation/landing/component/promo-detail/promo-detail.component';
import { PromoDetailData } from '@presentation/landing/component/promo-detail/promo-detail';
// pake relative path
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { CreateOrderRoamingUsecase } from '@usecase/checkout/create-order-roaming/create-order-roming.usecase';
import { CreateOrderRoamingDto, CreateOrderRoamingResp } from '@usecase/checkout/create-order-roaming/create-order-roaming.type';
import { DeviceIdService } from '@shared/services.device-id';
import { ErrorModalComponent } from '@shared/components/error-modal/error-modal.component';
import { errorMessageData } from '@shared/services/error-message/error-message.data';
import { ErrorModal } from '@shared/components/error-modal/error-modal.interface';
import { ITEM } from '@utils/constants';
import { CheckoutDetail } from '@usecase/checkout/checkout-detail/checkout-detail.usecase';
import { CheckoutDetailDto, CheckoutDetailResp } from '@usecase/checkout/checkout-detail/checkout-detail.type';
import { take } from 'rxjs';
import { CheckoutDetailData } from '@data/domain/checkout.entity';
import { WindowService } from '@shared/services.window';

@Component({
  selector: 'app-checkout',
  standalone: true,
  imports: [CurrencyPipe, InputEmailComponent, ReactiveFormsModule, LoaderComponent, TranslatePipe],
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.scss'
})
export class CheckoutComponent implements OnInit {
  packageDetailData!: Package;
  email: FormControl = new FormControl('');
  msisdn!: string;
  isEmailValid = signal<boolean>(true);
  checkoutData = signal<CheckoutDetailData | null>(null);

  readonly route = inject(ActivatedRoute);
  readonly dialog = inject(DialogService);
  readonly deviceIdService = inject(DeviceIdService);
  readonly getPackageDetailUsecase = inject(GetPackageDetailUsecase);
  readonly createOrderRoamingUsecase = inject(CreateOrderRoamingUsecase);
  readonly checkoutDetailUsecase = inject(CheckoutDetail);
  readonly windowService = inject(WindowService);

  ngOnInit(): void {
    this.msisdn = this.route.snapshot.queryParams['msisdn'];
    if (this.route.snapshot.queryParams['type'] === 'roamingUmrahHaji') {
      this.getPackageDetail();
    } else {
      this.getCheckoutDetail();
    }

  }

  getCheckoutDetail() {
    const payload: CheckoutDetailDto = {
      orderId: this.route.snapshot.params['mlid']
    };

    this.checkoutDetailUsecase.execute(payload).pipe(take(ITEM.SINGLE_EMISSION)).subscribe({
      next: (res: CheckoutDetailResp) => {
        this.checkoutData.set(res.data);
      }
    });
  }

  onClickRoamingDetail() {
    const data: PromoDetailData = {
      ...this.packageDetailData,
      isAffiliatePackage: false
    };
    this.dialog.open(PromoDetailComponent, {
      data: data
    });
  }

  getPackageDetail() {
    const { msisdn, packageId } = this.route.snapshot.queryParams;
    const payload: GetPackageDetailDto = {
      package_id: packageId,
      msisdn,
      captcha_type: 'no-captcha',
      'no-captcha': true,
      is_encrypted: true,
      source: 'service-order'
    };

    this.getPackageDetailUsecase.execute(payload).subscribe({
      next: (res: GetPackageDetailResp) => {
        this.packageDetailData = res;
      },
      error: () => {
        this.showModalError();
      }
    });
  }

  createOrder() {
    // jangan pernah passing data lewat query params, gampang di manipulate
    const { optionSelected, date, time } = this.route.snapshot.queryParams;

    const payload: CreateOrderRoamingDto = {
      msisdn: this.msisdn,
      tag: 'promo',
      deviceId: this.deviceIdService.getDeviceId(),
      email: this.email.value,
      activation_date: date ?? '',
      activation_hours: time ?? '',
      activation_option: optionSelected,
      telcoPackage: [
        {
          packageId: this.packageDetailData.businesspid ?? ''
        }
      ]
    };

    this.createOrderRoamingUsecase.execute(payload).subscribe({
      next: (res: CreateOrderRoamingResp) => {
        //  validate platformID
        this.windowService.assign(`${environment.drupalApi}shops/payment/${res.code}?type=roamingUmrahHaji`);
      },
      error: () => {
        this.showModalError();
      }
    });
  }

  clearLocalStorage() {
    //  validate platformID
    localStorage.removeItem('mlId');
    localStorage.removeItem('promoType');
  }

  showModalError() {
    const { title, description, image, firstButton } = errorMessageData[ITEM.EMPTY_LENGTH];
    const DATA: ErrorModal = {
      title,
      description,
      image,
      firstButton: {
        isBgRed: true,
        text: firstButton?.text ?? '',
        url: ''
      },
      secondButton: {
        isBgRed: false,
        text: '',
        url: ''
      }
    };
    this.dialog.open(ErrorModalComponent, {
      data: DATA
    });
  }
}
